import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { FC, ReactNode } from 'react';
import { NAVY, RADIUS_CARD, SHADOW, SURFACE_CONTAINER_LOWEST, YELLOW } from 'styles/tokens';

interface Props {
  caption: string;
  align: 'left' | 'right' | 'center';
  children: ReactNode;
  captionAction?: ReactNode;
  date?: string;
  /** When true, the bubble stretches to fill its container (e.g. to host a responsive chart). */
  fullWidth?: boolean;
  /** Explicit bubble background. Falls back to the align-based default when omitted. */
  bgcolor?: string;
}

const MessageWrapper: FC<Props> = ({
  children,
  caption,
  align,
  captionAction,
  date,
  fullWidth = false,
  bgcolor = undefined,
}: Props) => (
  <Box
    sx={{
      justifyContent: align,
      display: 'flex',
    }}
  >
    <Box
      sx={{
        bgcolor: bgcolor ?? (align === 'left' ? SURFACE_CONTAINER_LOWEST : alpha(YELLOW, 0.15)),
        boxShadow: align === 'left' ? SHADOW : 'none',
        borderRadius: RADIUS_CARD,
        padding: 2,
        paddingTop: 1.25,
        maxWidth: fullWidth ? '100%' : '88%',
        width: fullWidth ? '100%' : undefined,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography
            variant="caption"
            sx={{
              fontFamily: 'Jost, sans-serif',
              fontWeight: 700,
              color: NAVY,
            }}
          >
            {caption}
          </Typography>
          {date && (
            <Typography
              variant="caption"
              sx={{
                fontFamily: 'Jost, sans-serif',
                color: `${NAVY}77`,
                fontSize: '0.7rem',
              }}
            >
              {new Date(date).toLocaleString('es-CL')}
            </Typography>
          )}
        </Box>
        {captionAction}
      </Box>
      {children}
    </Box>
  </Box>
);

export default MessageWrapper;
